




import {Component, Prop, Vue} from "vue-property-decorator";
import {IdMapper} from "@/interfaces/state/base";
import {LadingStatus} from "@/enums/status";

@Component({
    name: "LadingStatusLabel"
})
export default class extends Vue {
    @Prop({ required: true })
    readonly status!: number;
    LadingStatus = LadingStatus;
    colorMap: IdMapper<string> = {
        [LadingStatus.GdKhoiTao]: 'blue',
        [LadingStatus.DuyetHoan]: 'yellow',
        [LadingStatus.DangHoan]: 'orange',
        [LadingStatus.HoanThanhCong]: 'green',
        [LadingStatus.NhapKhoGiaoHang]: 'green',
        [LadingStatus.NhapKhoChuyenVung]: 'green',
        [LadingStatus.DangChuyenVung]: 'green',
        [LadingStatus.LayHangThanhCong]: 'green',
        [LadingStatus.ChoCapNhat]: 'yellow',
        [LadingStatus.LayHangThanhCongChoCapNhat]: 'yellow',
        [LadingStatus.ChoLayHang]: 'yellow',
        [LadingStatus.PhanCongPhat]: 'yellow',
        [LadingStatus.DiPhat]: 'yellow',
        [LadingStatus.PhatThanhCong]: 'yellow',
        [LadingStatus.PhatLai]: 'yellow',
        [LadingStatus.DonSuCo]: 'yellow',
        [LadingStatus.NhapKhoChoCapNhat]: 'yellow',
        [LadingStatus.NhapKhoChuyenHoan]: 'yellow',
        [LadingStatus.DuyetChuyenTiep]: 'yellow',
        [LadingStatus.DiHoan]: 'yellow',
        [LadingStatus.ChuyenTiep]: 'yellow',
        [LadingStatus.PhanCongHoan]: 'yellow',
        [LadingStatus.Reject]: 'red',
    }
}
